/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ProgressBarController", ["ValueContainerControllerBase", "ControllerFactory"], function (context, cls) {
  /**
   * @class ProgressBarController
   * @memberOf classes
   * @extends classes.ValueContainerControllerBase
   */
  class ProgressBarController extends cls.ValueContainerControllerBase /** @lends classes.ProgressBarController.prototype */ {
    static __name = "ProgressBarController";

    _initBehaviors() {
      super._initBehaviors();

      // These behaviors should stay added at first
      // WARNING : DO NOT ADD BEHAVIORS BEFORE
      if (this.isInTable()) {
        this._addBehavior(cls.TableSizeVMBehavior);
      }
      if (!this.isInTable() || this.isInFirstTableRow()) {
        this._addBehavior(cls.LayoutInfoVMBehavior);
      }
      this._addBehavior(cls.StyleVMBehavior);
      // END WARNING

      // pseudo-selector behaviors
      this._addBehavior(cls.ActivePseudoSelectorBehavior);
      this._addBehavior(cls.DialogTypePseudoSelectorBehavior);
      if (this.isInMatrix()) {
        this._addBehavior(cls.MatrixCurrentRowVMBehavior);
      }
      this._addBehavior(cls.FontStyle4STBehavior);
      this._addBehavior(cls.FontSize4STBehavior);
      this._addBehavior(cls.FontColor4STBehavior);
      this._addBehavior(cls.Border4STBehavior);
      this._addBehavior(cls.Percentage4STBehavior);
      this._addBehavior(cls.Reverse4STBehavior);

      // vm behaviors
      this._addBehavior(cls.EnabledVMBehavior);
      this._addBehavior(cls.HiddenVMBehavior);
      this._addBehavior(cls.ColorVMBehavior);
      this._addBehavior(cls.BackgroundColorVMBehavior);
      this._addBehavior(cls.FontWeightVMBehavior);
      this._addBehavior(cls.FontFamilyVMBehavior);
      this._addBehavior(cls.TextDecorationVMBehavior);
      this._addBehavior(cls.RangeVMBehavior); // range before value! to calculate percentage
      this._addBehavior(cls.ValueVMBehavior);
      this._addBehavior(cls.TitleVMBehavior);
      this._addBehavior(cls.StretchVMBehavior);

      // ui behaviors
      this._addBehavior(cls.RequestFocusUIBehavior);
      if (this.isInTable()) {
        this._addBehavior(cls.TableImageVMBehavior);
        this._addBehavior(cls.RowSelectionUIBehavior);
        this._addBehavior(cls.TableItemCurrentRowVMBehavior);
      }
    }

    _createWidget(type) {
      const widget = super._createWidget(type);
      if (widget.setRunning) {
        widget.setRunning(true);
      }
      return widget;
    }
  }

  cls.ProgressBarController = ProgressBarController;
  cls.ControllerFactory.register("ProgressBar", cls.ProgressBarController);
});
